import { useTranslation } from "gatsby-plugin-react-i18next";
import React, { FormEvent, useState } from "react";
import Helmet from "react-helmet";
import "twin.macro";

import { ContactUsForm } from "../components/ContactUsForm";
import { Container } from "../components/Container";
import { Layout } from "../components/Layout/Layout";
import { ContactForm } from "../interfaces/contact_form";
import { submitContactForm } from "../services/web3forms";

const initForm: ContactForm = {
  firstName: "",
  lastName: "",
  email: "",
  message: "",
  contactReason: "3",
  botcheck: false,
  agreement: false,
  lang: "en",
  phoneNumber: ""
};

const ContactUs: React.FC = ({}) => {
  const { i18n, t } = useTranslation();
  const [form, setForm] = useState<ContactForm>(initForm);
  const [hasError, setHasError] = useState<boolean>(false);
  const [successful, setSuccessful] = useState<boolean>(false);
  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    form.lang = i18n.language;

    submitContactForm(form, "Contact form — triangular-pod.com")
      .then(() => {
        setHasError(false);
        setSuccessful(true);
      })
      .then(() => setForm(initForm))
      .catch(() => {
        setSuccessful(false);
        setHasError(true);
      });
  };

  const status = { error: hasError, success: successful };

  return (
    <Layout>
      <Helmet title={t("contactUs.header")} />
      <Container tw="pt-16 pb-32">
        <article tw="mx-auto text-center max-w-prose">
          <h1 tw="font-black text-4xl">{t("contactUs.header")}</h1>
          <p tw="mt-8 mx-auto text-2xl">{t("contactUs.hereForYou")}</p>
          <p tw="mt-8 mb-16 mx-auto text-2xl">{t("contactUs.subheader")}</p>
        </article>
        <ContactUsForm form={form} setForm={setForm} handleSubmit={handleSubmit} status={status} />
      </Container>
    </Layout>
  );
};

export default ContactUs;
